// extracted by mini-css-extract-plugin
export var icon = "EntrySkeleton-module--icon--79871";
export var inner = "EntrySkeleton-module--inner--e7775";